import { Component, OnInit, HostListener, ViewChild, ElementRef, Inject, Directive } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SeoService } from '../../services/seo.service';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';

import { IParallaxScrollConfig } from 'ngx-parallax-scroll';

/* import ScrollBound from "scroll-bound-animation";
var data = require("./animation-mena.json");
new ScrollBound(data); */

import AOS from "aos";

@Directive({ selector: 'img' })
export class LazyImgDirective {
  constructor({ nativeElement }: ElementRef<HTMLImageElement>) {
    const supports = 'loading' in HTMLImageElement.prototype;

    if (supports) {
      nativeElement.setAttribute('loading', 'lazy');
    }
  }
}

@Component({
  selector: 'app-mena-region',
  templateUrl: './mena-region.component.html',
  styleUrls: ['./mena-region.component.scss']
})
export class MenaRegionComponent implements OnInit {
  public stream ='https://player.vimeo.com/external/856004892.m3u8?s=e748de1c2df10810a5276298f7e7c19c3ef4f8de&logging=false';
  public stream2 ='https://player.vimeo.com/external/856004900.m3u8?s=2b5a99fb31cb7e18073743a6c9ac22c65ce0d38d&logging=false';
  public stream3='https://player.vimeo.com/external/856004907.m3u8?s=aa6841838bfda71d5ba8a50641a1fef125b08a2d&logging=false';
  public stream4 ='https://player.vimeo.com/external/856004919.m3u8?s=317270465b9d37fa7349a3cf6a5921b132439e4c&logging=false';
  public stream5 ='https://player.vimeo.com/external/856004959.m3u8?s=7629179997a2eda8c9be42344cfceb3539ace1f2&logging=false';
  public stream6 ='https://player.vimeo.com/external/856004931.m3u8?s=6c1d04227eaf43119c8f708127b435f5cffe0d23&logging=false';

  
  pdfSrc = './assets/docs/Seed-Group-onboards-Gennius-XYZ-to-transform-the-digital-asset-ecosystem-in-MENA.pdf'

  images=[
    './assets/img/gennius/agreement2.webp',
    './assets/img/gennius/agreement6.webp',
    './assets/img/gennius/agreement4.webp',
    './assets/img/gennius/agreement3.webp',
    './assets/img/gennius/agreement5.webp',

  ]

  hash: any;
  public video1: boolean;
  public video2: boolean;
  public video3: boolean;
  public video4: boolean;
  public video5: boolean;
  public video6: boolean;
  public video7: boolean;
  public video8: boolean;
  public video9: boolean;
  public video10: boolean;
  public video11: boolean;

  public show:boolean;
  public play1:boolean;
  public play2:boolean;
  public play3:boolean;
  public play4:boolean;
  public play5:boolean;
  public play6:boolean;

  public playVideo1:boolean;
  public playVideo2:boolean;
  public playVideo3:boolean;
  public playVideo4:boolean;
  public playVideo5:boolean;
  public playVideo6:boolean;

  ngParallaxConf: IParallaxScrollConfig = {
    parallaxSpeed: 1,
    parallaxSmoothness: 1,
    parallaxDirection: 'reverse',
    parallaxTimingFunction: 'ease-in',
    parallaxThrottleTime: 80
  };

  public fixed:boolean;
  public scroll:boolean;
  public itsMobile = false;

  constructor(private el: ElementRef, @Inject(DOCUMENT) private document: any,private title: Title, private seo: SeoService) {
    this.hash = window.location.hash;

  }

  /* @HostListener('body:scroll', ['$event'])
  onScrollingEvent($event): void {
     let scrollOffset = $event.target.scrollTop;
     console.log(scrollOffset)

  } */

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const image = this.el.nativeElement.querySelector('.img-cymi');

    const logOne = this.el.nativeElement.querySelectorAll('.logo-cymi-aos');
    const logoCymi = this.el.nativeElement.querySelector('.al');

    const sectionVideo = this.el.nativeElement.querySelectorAll('.video-play');

    for (var val of logOne) {
      if(val.classList.contains('four') || val.classList.contains('five')){
        if(offset >= val.offsetTop - 500){
          val.classList.add('animate');
        }else{
          val.classList.remove('animate');
        }
      }else{
        if(offset >= val.offsetTop - 400){
          val.classList.add('animate');
        }else{
          val.classList.remove('animate');
        }
      }

    }

    if(offset == 0){
      image.style.transform = 'translateY(0)';
      image.style.opacity = '1';
    }

    if(offset >= logoCymi.offsetTop - 300){
      logoCymi.classList.add('animate');
    }else{
      logoCymi.classList.remove('animate');
    }

    for (var val of sectionVideo) {
      if(offset >= val.offsetTop - 300){

        if(val.className == 'first-child video-play'){
          const video = this.el.nativeElement.querySelector('.first-child .right video');
          video.play();
        }else if(val.className == 'fund-middle second video-play'){
          const video = this.el.nativeElement.querySelector('.second .left video');
          video.play();
        }else if(val.className == 'third video-play'){
          const video = this.el.nativeElement.querySelector('.third .right video');
          video.play();
        }else if(val.className == 'fund-middle fourth video-play'){
          const video = this.el.nativeElement.querySelector('.fourth .left video');
          video.play();
        }else if(val.className == 'fifth video-play'){
          const video = this.el.nativeElement.querySelector('.fifth .right video');
          video.play();
        }else if(val.className == 'fund-middle sixth video-play'){
          const video = this.el.nativeElement.querySelector('.sixth .left video');
          video.play();
        }
      }

    }

  }

  loadAssets() {
    let elementsSrc = document.querySelectorAll('[src-tmp]');

    elementsSrc.forEach((theElement: any) => {
      if (theElement.src != undefined) {
        theElement.src = theElement.getAttribute('src-tmp');
        theElement.removeAttribute('src-tmp');
      }
    });

    // $.each(, function (index, theElement) {
    //
    // });
  }

  ngOnInit(): void {
    if (this.verifyMobile()) {
      this.itsMobile = true;
    }

    AOS.init();

    this.loadAssets();

    const theTitle = 'MENA Region';
    this.title.setTitle(theTitle);

    this.seo.generateTags({
      title: theTitle,
      keyword: '',
      description: "",
      image: ''
    });

  }

  verifyMobile(): any {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];


    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  openVideo(number: any) {
    
    this["video" + number] = true;
    this.pauseAllVideos();

    setTimeout(() => {
      this.loadAssets();
      if (number == '1') {
        const video = this.el.nativeElement.querySelector('video.main-intro');
        video.play();
      }
      else if (number == '2') {
        const video = this.el.nativeElement.querySelector('video.main-video');
        video.load();
        video.play();
      }else if (number == '3') {
        const video = this.el.nativeElement.querySelector('video.main-video2');
        video.load();
        video.play();
      }else if (number == '4') {
        const video = this.el.nativeElement.querySelector('video.main-video3');
        video.load();
        video.play();
      }else if (number == '5') {
        const video = this.el.nativeElement.querySelector('video.main-video4');
        video.load();
        video.play();
      }else if (number == '6') {
        const video = this.el.nativeElement.querySelector('video.main-video5');
        video.load();
        video.play();
      }else if (number == '7') {
        const video = this.el.nativeElement.querySelector('video.main-video6');
        video.load();
        video.play();
      }else if (number == '8') {
        const video = this.el.nativeElement.querySelector('video.main-video7');
        video.play();
      }else if (number == '9') {
        const video = this.el.nativeElement.querySelector('video.main-intro2');
        video.play();
      }else if (number == '10') {
        const video = this.el.nativeElement.querySelector('video.main-video10');
      }else if (number == '11') {
        const video = this.el.nativeElement.querySelector('video.main-intro3');
        video.load();
        video.play();
      }
    }, 1000);

  }

  closeVideo(number: any) {
    this["video" + number] = false;
    if (number == '1') {
      const video = this.el.nativeElement.querySelector('video.main-intro');
      video.pause();
    }else if (number == '2') {
        const video = this.el.nativeElement.querySelector('video.main-video');
        video.pause();
    }else if (number == '3') {
      const video = this.el.nativeElement.querySelector('video.main-video2');
      video.pause();
    }else if (number == '4') {
      const video = this.el.nativeElement.querySelector('video.main-video3');
      video.pause();
    }else if (number == '5') {
      const video = this.el.nativeElement.querySelector('video.main-video4');
      video.pause();
    }else if (number == '6') {
      const video = this.el.nativeElement.querySelector('video.main-video5');
      video.pause();
    }else if (number == '7') {
      const video = this.el.nativeElement.querySelector('video.main-video6');
      video.pause();
    }else if (number == '8') {
      const video = this.el.nativeElement.querySelector('video.main-video7');
      video.pause();
    }else if (number == '9') {
      const video = this.el.nativeElement.querySelector('video.main-intro2');
      video.pause();
    }else if (number == '10') {
      const video = this.el.nativeElement.querySelector('video.main-video10');
    }else if (number == '11') {
      const video = this.el.nativeElement.querySelector('video.main-intro3');
      video.pause();
    }
  }


  pauseAllVideos(event?) {
    document.querySelectorAll('video').forEach((elem: any) => {
      if (elem) {
        try {
          elem.currentTime = 0;
          elem.load();
          elem.pause();
        } catch (error) {
        }
      }
    });
  }

  openModal(){
    this.show = true;
  }

  closeModal(){
    this.show = false;
  }

  actionVideo(number: any){
    if(number == '1'){
      this.playVideo1 = true;
      this.play1 = !this.play1;
      if(this.play1 == true){
        const video = this.el.nativeElement.querySelector('video.video-mask1');
        video.play();
      }else{
        const video = this.el.nativeElement.querySelector('video.video-mask1');
        video.pause();
      }
    }else if(number == '2'){
      this.playVideo2 = true;
      this.play2 = !this.play2;
      if(this.play2 == true){
        const video = this.el.nativeElement.querySelector('video.video-mask2');
        video.play();
      }else{
        const video = this.el.nativeElement.querySelector('video.video-mask2');
        video.pause();
      }
    }else if(number == '3'){
      this.playVideo3 = true;
      this.play3 = !this.play3;
      if(this.play3 == true){
        const video = this.el.nativeElement.querySelector('video.video-mask3');
        video.play();
      }else{
        const video = this.el.nativeElement.querySelector('video.video-mask3');
        video.pause();
      }
    }else if(number == '4'){
      this.playVideo4 = true;
      this.play4 = !this.play4;
      if(this.play4 == true){
        const video = this.el.nativeElement.querySelector('video.video-mask4');
        video.play();
      }else{
        const video = this.el.nativeElement.querySelector('video.video-mask4');
        video.pause();
      }
    }else if(number == '5'){
      this.playVideo5 = true;
      this.play5 = !this.play5;
      if(this.play5 == true){
        const video = this.el.nativeElement.querySelector('video.video-mask5');
        video.play();
      }else{
        const video = this.el.nativeElement.querySelector('video.video-mask5');
        video.pause();
      }
    }else if(number == '6'){
      this.playVideo6 = true;
      this.play6 = !this.play6;
      if(this.play6 == true){
        const video = this.el.nativeElement.querySelector('video.video-mask6');
        video.play();
      }else{
        const video = this.el.nativeElement.querySelector('video.video-mask6');
        video.pause();
      }
    }

  }

  videoEnd(number: any) {
    if (number == '1') {
      this.playVideo1 = false;
      this.play1 = false;
      const video = this.el.nativeElement.querySelector('video.video-mask1');
      video.load();
    }else if (number == '2') {
      this.playVideo2 = false;
      this.play2 = false;
      const video = this.el.nativeElement.querySelector('video.video-mask2');
      video.load();
    }else if (number == '3') {
      this.playVideo3 = false;
      this.play3 = false;
      const video = this.el.nativeElement.querySelector('video.video-mask3');
      video.load();
    }else if (number == '4') {
      this.playVideo4 = false;
      this.play4 = false;
      const video = this.el.nativeElement.querySelector('video.video-mask4');
      video.load();
    }else if (number == '5') {
      this.playVideo5 = false;
      this.play5 = false;
      const video = this.el.nativeElement.querySelector('video.video-mask5');
      video.load();
    }else if (number == '6') {
      this.playVideo6 = false;
      this.play6 = false;
      const video = this.el.nativeElement.querySelector('video.video-mask6');
      video.load();
    }
  }

}
